export default __webpack_public_path__ + "static/media/2392.621ea2c8.png";